import { PlusOutlined } from '@ant-design/icons'
import { FC } from 'react'
import styled from 'styled-components'

const Root = styled.div`
    width: 218px;
    height: 170px;
    border: 2px solid gray;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    * {
        box-sizing: border-box;
    }
`

const Icon = styled(PlusOutlined)`
    font-size: 32px;
    color: gray;
`

interface AddStampTubeLabelProps {
    onClick: () => void
}

const AddStampTubeLabel: FC<AddStampTubeLabelProps> = ({ onClick }) => {
    return (
        <Root onClick={onClick}>
            <Icon />
        </Root>
    )
}

export default AddStampTubeLabel
